export const SITE = window.location.hostname.startsWith('inv.') ? 'general' : 'auto';
export const SITE_IS_AUTO = SITE === 'auto';
export const SITE_IS_GENERAL = SITE === 'general';
export const IS_UAT = window.location.hostname.indexOf('.dev.') > -1;
export const IS_DEMO = window.location.hostname.indexOf('.demo.') > -1;
export const IS_PROD = !IS_UAT && !IS_DEMO;
export const NEWLINE = '\n';
export const NDASH = '\u2013';
export const MDASH = '\u2014';
export const MIDDOT = '\u00b7';
export const QUERYSTRING = window.location.search;
export const IMAGE_PARTSTECH_LOGO = '/assets/img/parts-tech-logo.svg';
export const PLANS = {
    Essentials: 'essentials',
    Pro: 'pro',
    Elite: 'elite',
};
export const SUBSCRIPTION_STATUS = {
    PendingPaymentCreate: 'PENDING-PAYMENT-CREATE',
    PaymentFailed: 'PAYMENT-FAILED',
    PaymentDeclined: 'PAYMENT-DECLINED',
    Cancelling: 'CANCELLING',
    Cancelled: 'CANCELLED',
    Active: 'ACTIVE',
};
export const TRANSACTION_STATUS = {
    'PROCESSED': 'PROCESSED',
    'FAILED': 'FAILED',
    'DECLINED': 'DECLINED',
};
export const SUBSCRIPTION_PLANS = {
    [PLANS.Essentials]: {
        title: 'Essentials',
        subtitle: 'Perfect for Getting Started',
        price: 59,
        frequency: 'month',
        featureList: [
            'Unlimited invoices/estimates',
            'Unlimited users',
            'Profit and loss per job reports',
            'Text or email payment links',
            'Daily transaction reports',
            'Appointment reminders by email/text',
            'Integrated payment processing',
            'Text estimates for approval',
        ],
        footnote: '(No Labor Guide)',
    },
    [PLANS.Pro]: {
        title: 'Pro',
        subtitle: 'Includes Labor Guide',
        price: 119,
        frequency: 'month',
        featureList: [
            'Everything in Essentials',
            'Labor Guide',
            'Retail Pricing Matrix',
            'Advanced analytics & insights',
        ],
        notes: { title: 'Includes PartsTech Complete', description: '$95/mo value at no additional cost.' },
    },
    [PLANS.Elite]: {
        title: 'Elite',
        subtitle: 'Includes Digital Inspections',
        price: 149,
        frequency: 'month',
        featureList: [
            'Everything in Pro & Essentials',
            'OEM Maintenance Schedules',
            'Vehicle Specifications for Fluids',
            'Digital Inspections',
        ],
        notes: { title: 'Includes PartsTech Complete', description: '$95/mo value at no additional cost.' },
    },
};
export const TAX_RATE = 0;
export const MONTHLY_PAYMENT_PROCESSING_FEE = 24;
export const ANNUAL_PAYMENT_PROCESSING_FEE = 49;
export const PAYMENT_PROCESSING_FEE_FREQUENCY = 'mo';
export const SUPPORT_EMAIL = 'support@myrateremover.com';
// Free professional website build offered to any software plan. Merchant pays $39/mo hosting only.
export const WEBSITE_ADDON_MONTHLY_FEE = 39;
export const TEXT = {
    'ORDER_TITLE': SITE === 'auto' ? 'Repair Order' : 'Order',
    'ORDERS_TITLE': SITE === 'auto' ? 'Repair Orders' : 'Orders',
    'ORDER_TITLE_WITH_ARTICLE': SITE === 'auto' ? 'a Repair Order' : 'an Order',
    'ORDERS_TITLE_WITH_ARTICLE': SITE === 'auto' ? 'the Repair Orders' : 'the Orders',
    'PERFORMER_LABEL': SITE === 'auto' ? 'Technician' : 'User',
    'PERFORMERS_LABEL': SITE === 'auto' ? 'Technicians' : 'Users',
    'LEAD_PERFORMER_LABEL': SITE === 'auto' ? 'Lead Technician' : 'User',
};
